export const bannersLocations = ['home', 'dance']
